export const environment = {
  production: true,
  envSuffix: ' ┃ ACP',
  redirectUri: 'https://checklist.test.sla-outbound-kd.devtest.gf.aws.scania.com/',
  urlApi: 'https://checklist-api.test.sla-outbound-kd.devtest.gf.aws.scania.com/',
};
